import isUndefined from 'lodash/isUndefined';

import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../translations';

type AvailabilityCreationPanelLoaderProps = {
   readonly children: JSX.Element;
   readonly healthcareLocationsLoading: boolean;
   readonly healthcareLocations: HealthcareProviderLocation[] | undefined;
};

export const AvailabilityCreationPanelLoader = (props: AvailabilityCreationPanelLoaderProps): JSX.Element => {
   if (props.healthcareLocationsLoading) {
      return <LoaderSpinner />;
   }

   if (isUndefined(props.healthcareLocations)) {
      return (
         <Message
            testId={'availabilityDataFetchError'}
            type={MessageType.NEGATIVE}
            label={personnelTranslationKeys.availability.create.form.errors.fetchData}
            displayIndicator
         />
      );
   }

   return props.children;
};
